import { isEmpty } from 'lodash';

import getBreakCode from 'Domain/monitoring/helper/getBreakCode';

const getBreakResponse = (response) => {
  if (isEmpty(response?.breakDetail)) return {};

  let result = {};

  response?.breakDetail?.forEach((item) => {
    const code = getBreakCode(item?.code);

    let isDisabled = false;

    if (code === 'toiletBreak' || code === 'mealBreak') isDisabled = item?.remainingDurationMin <= 0 || item?.usedCount >= item?.maxPerShift;
    else isDisabled = item?.usedCount >= item?.maxPerShift;

    const breakItem = {
      code,
      isDisabled,
      id: item?.id,
      name: item?.name,
      used: item?.usedCount ?? 0,
      total: item?.maxPerShift ?? 0,
      usedDuration: item?.usedDurationMin ?? 0,
      totalDuration: item?.maxDurationMin ?? 0,
      remainingDuration: item?.remainingDurationMin ?? 0,
    };

    result[code] = breakItem;
  });

  return result;
};

export default getBreakResponse;
